import { render } from "./TIFH.vue?vue&type=template&id=df5afd7a&scoped=true&ts=true"
import script from "./TIFH.vue?vue&type=script&lang=ts"
export * from "./TIFH.vue?vue&type=script&lang=ts"

import "./TIFH.vue?vue&type=style&index=0&id=df5afd7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5afd7a"]])

export default __exports__